<template>
  <header
    class="navbar sticky-top flex-md-nowrap p-0"
    style="background-color: #058cf5"
  >
    <a class="navbar-brand col-lg-2 px-3 fs-6" href="/">
      <img
        id="logo"
        class="rounded border border-white"
        src="../../../app/assets/logo.png"
      />
    </a>
    <button
      class="navbar-toggler border-0 shadow-none d-lg-none"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasResponsive"
      aria-controls="offcanvasResponsive"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
  </header>
  <RouterView />
</template>

<style>
@media (min-width: 992px) {
  .sidebar {
    top: 60px;
  }
}
</style>
